import type { FormErrors, ApplicationFormData } from "../types";

/**
 * Client-side form validation utilities
 */

/**
 * Validates the application form data
 *
 * @param data - Form data to validate
 * @returns Object containing validation errors (empty if valid)
 */
export const validateForm = (data: ApplicationFormData): FormErrors => {
  const errors: FormErrors = {};

  // Name validation
  if (!data.name.trim()) {
    errors.name = "Name is required";
  } else if (data.name.trim().length < 2) {
    errors.name = "Name must be at least 2 characters";
  } else if (data.name.trim().length > 100) {
    errors.name = "Name must be less than 100 characters";
  }

  // Email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!data.email.trim()) {
    errors.email = "Email is required";
  } else if (!emailRegex.test(data.email)) {
    errors.email = "Please enter a valid email address";
  }

  // Phone validation (Indian mobile number)
  const phoneRegex = /^[6-9]\d{9}$/;
  if (!data.phone.trim()) {
    errors.phone = "Phone number is required";
  } else if (!phoneRegex.test(data.phone)) {
    errors.phone = "Please enter a valid 10-digit Indian mobile number";
  }

  // Course selection validation
  if (!data.courseId) {
    errors.courseId = "Please select a course";
  }

  return errors;
};

/**
 * Checks if form has any validation errors
 */
export const hasErrors = (errors: FormErrors): boolean => {
  return Object.keys(errors).length > 0;
};

/**
 * Formats price in INR
 */
export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(price);
};
